import { setAccessToken } from '@/lib';
import authApi from './authApi';
import type { smsCodeProps } from './type';

// 登录接口
export const login = async (values: API.LoginParams) => {
  const res = await authApi.post('/login', values);
  return res;
};

// 退出登录接口
export const logout = async () => {
  const res = await authApi.get('/logout');
  return res;
};

// 获取图形码
export const getCaptcha = async () => {
  const res = (await authApi.get('/captcha/graph')) as {
    captchaId: string;
    image: string;
  };
  return res;
};

// 获取图形码 算术表达式
export const getCaptchaMath = async () => {
  const res = await authApi.get('/captcha/math');
  return res;
};

// 获取图形码 trek
export const getCaptchaTrek = async () => {
  const res = await authApi.get('/captcha/trek');
  return res;
};

// 获取手机验证码
export const getSms = async (values: { phone: string }) => {
  const res = (await authApi.post('/sms/send', values)) as { code: number };
  return res;
};

// 校验验证码
export const checkSmsCode = async (values: smsCodeProps) => {
  const res = await authApi.post('/sms/verify', values);
  return res;
};

// 获取用户信息
export const getUserByRefresh = async () => {
  const res = (await authApi.get('/refresh')) as {
    accessToken: string;
    userInfo: any;
  };
  return res;
};

// 刷新token
export async function refreshToken() {
  // const refreshToken = getStorageItem('refreshToken');
  // if (!refreshToken) return Promise.reject(new Error('no refreshToken'));

  const data = await authApi.get<any, { accessToken?: string }>('/refresh', {
    withCredentials: true,
  }); //cookie带上
  if (!data?.accessToken) {
    return Promise.reject(new Error('刷新失败'));
  }

  const { accessToken } = data;
  setAccessToken(accessToken);
  // if (newRefreshToken) {
  //     setStorageItem('refreshToken', refreshToken)
  // }

  return accessToken;
}
